export const deliveryIndexFields = [
  {
    key: 'order',
    label: 'Urutan',
  },
  {
    key: 'name',
    label: 'Nama Kolom',
  },
  {
    key: 'type',
    label: 'Tipe Kolom',
  },
  {
    key: 'is_required',
    label: 'Wajib Diisi',
  },
  {
    key: 'is_active',
    label: 'Aktif',
  },
]